import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { RouterContext } from '@/app/router';
import { NotFoundView, RouteErrorView, SkipLink } from '@hlt/web-kit/shell';

export const Route = createRootRouteWithContext<RouterContext>()({
    component: () => (
        <>
            <SkipLink />
            <Outlet />
        </>
    ),
    notFoundComponent: NotFoundView,
    errorComponent: RouteErrorView,
});
